<div *ngIf="showGrid" id="token-activity" class="token-activity mt-4" [attr.aria-label]="getTitle()">
    <div role="heading"  tabindex="-1" id="token-activiity-title" aria-level="2" [attr.aria-label] = "ariaLabelForToken" class="title-md-bold">{{getTitle()}}
        <div *ngIf="loading" alt="Loading..." class="small progress">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
    <div>{{disclaimerText}}</div>
    <div *ngIf="tokenActivity.length == 0" class="list-container mt-3">
        <div class="empty-list">
            <div>
                <div class="message">{{noActivityMessage}}</div>
                <div>{{noActivityAdditionalMessage}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="tokenActivity.length > 0" class="token-activity__container mt-3">
        <ng-container *ngFor="let activity of tokenActivity; let i = index; let isFirst = first">
            <div *ngIf="!isFirst && i < displayCount" class="token-activity-item__separator"></div>
            <div *ngIf="i < displayCount" class="token-activity__item" [attr.id]="i === displayCount - itemsVisible ? 'newActivity' : null">
                <div class="token-activity-item__left">
                    <div class="token-activity-item-left__date price-lg" aria-hidden="true">{{ getDisplayDate(activity) | date: 'shortDate' }}</div>
                    <div class="sr-only">{{ getReadableDate(activity) }}</div>
                    <div class="token-activity-item-left__for body-text body-text-xs">{{ activity.activity }}</div>
                </div>
                <div class="token-activity-item__right">
                    <div class="token-activity-item-right__tokens price-lg {{ activity.transactionType | lowercase }}">{{ tokenLabel(activity.quantityProcessed, activity.transactionType) }}</div>
                    <div *ngIf="gameType == GAMETYPES.EPISODIC && (activity.transactionType == TRANSACTIONTYPES.EARN || activity.transactionType == TRANSACTIONTYPES.BURN)" class="token-activity-item-right__rewards body-text body-text-xs">{{ activity.totalBalance }} Total Gameplays</div>
                    <div *ngIf="gameType == GAMETYPES.EPISODIC && (activity.transactionType == TRANSACTIONTYPES.SWEEPSTAKES)" class="token-activity-item-right__rewards body-text body-text-xs">{{ activity.totalBalance }} Total Sweepstakes Entries</div>
                    <div *ngIf="gameType != GAMETYPES.EPISODIC" class="token-activity-item-right__rewards body-text body-text-xs">{{ activity.totalBalance }} Total {{ activity.totalBalance == 1 ? tokenLabelSingular : tokenLabelPlural }}</div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="mt-4 mb-4 load-more__container" *ngIf="displayCount < tokenActivity.length">
        <button class="btn btn-xl btn-secondary" tabindex="0" role="button" (click)="showMore()">Show more <span class="sr-only">{{ getTitle() }}</span></button>
    </div>
    
</div>
